"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Device = void 0;
exports.Device = {
    android: 'android',
    ios: 'ios',
    etc: 'etc', // desktop
};
